import React, {useEffect, useState} from "react";
import HeaderComponent from "../../components/HeaderComponent";
import "./../../utils/Style/pages/Merchantinformation.scss";
import MerchantInformationAPI from "../../api/MerchantInformationAPI";
import {setFlag, setResponseInfo} from "../../features/responseSlice";
import {useDispatch, useSelector} from "react-redux";
import MerchantDetails from "../../components/MerchantInformation/MerchantDetails";
import LegalDetails from "../../components/MerchantInformation/LegalDetails";
import BlurLoading from "../../components/BlurLoading";
import {useNavigate} from "react-router-dom";

function Merchantinformation() {
    const {GetMerchantInformation, GetMerchantsInfoList, merchantLoading} = MerchantInformationAPI();
    const {flag, loading} = useSelector((state) => state.transferResponse);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        GetMerchantInformation();
    }, []);

    useEffect(() => {
        if ([0, 1].includes(flag)) {
            GetMerchantInformation();
            dispatch(setFlag(null));
            dispatch(setResponseInfo({}));
        }
    }, [flag]);

    const [merchantsInfoList, setMerchantsInfoList] = useState([]);
    const [selectedMerchant, setSelectedMerchant] = useState(null);
    const [activeButton, setActiveButton] = useState("");

    useEffect(() => {
        const fetchedMerchantsInfoList = GetMerchantsInfoList?.MerchantsInfoList || [];
        setMerchantsInfoList(fetchedMerchantsInfoList);
        setSelectedMerchant(fetchedMerchantsInfoList[0]);
        setActiveButton(fetchedMerchantsInfoList[0]?.MerchantGeneralInfo?.MerchantLegalName);
    }, [GetMerchantsInfoList]);

    const handleMerchantClick = (merchant, event) => {
        setSelectedMerchant(merchant);
        setActiveButton(merchant.MerchantGeneralInfo.MerchantLegalName);
    };


    return (
        <>
            {loading === "pending" && <BlurLoading/>}
            {
                sessionStorage.getItem("EntityType") === "LEGALENTITY" &&
                <>
                    <HeaderComponent title="Legal Information"/>
                    <div className="MerchantinformationPage">
                        <div className="container-fluid Merchantinformationcontainer">
                            <LegalDetails merchantLoading={merchantLoading}
                                          entity={GetMerchantsInfoList?.LegalInformation}/>
                            <div className="top-header">
                                <div className="top_section">
                                    {merchantsInfoList.map((merchant) => (
                                        <button
                                            key={merchant.MerchantID}
                                            className={`navButton ${activeButton === merchant.MerchantGeneralInfo.MerchantLegalName ? "active" : ""}`}
                                            onClick={() => handleMerchantClick(merchant)}
                                        >
                                            {merchant.MerchantGeneralInfo.MerchantLegalName}
                                        </button>
                                    ))}
                                </div>
                                <button
                                    id="button"
                                    onClick={() => {
                                        navigate("/merchant-enrollment/1");
                                    }}>
                                    Add Merchant
                                </button>
                            </div>
                            {selectedMerchant && (
                                <MerchantDetails merchant={selectedMerchant} merchantLoading={merchantLoading}/>
                            )}
                        </div>
                    </div>
                </>
            }

            {
                sessionStorage.getItem("EntityType") === "MERCHANTEMPLOYEE" &&
                <>
                    <HeaderComponent title="Merchant Information"/>
                    <div className="MerchantinformationPage merchant-template">
                        <div className="container-fluid Merchantinformationcontainer">
                            {selectedMerchant && (
                                <MerchantDetails merchant={selectedMerchant} merchantLoading={merchantLoading}/>
                            )}
                        </div>
                    </div>
                </>
            }

        </>
    );
}


export default Merchantinformation;
